import React from "react";
import { Navigate } from "react-router-dom";
import PendingApproval from "./pages/PendingApproval";

// Signed in, but no roles at all -> SSO self-join awaiting an admin's approval.
const hasNoRoles = (): boolean => {
  try {
    const u = JSON.parse(localStorage.getItem("user_info") || "null");
    return !!u && Array.isArray(u.roles) && u.roles.length === 0;
  } catch {
    return false;
  }
};

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const token = localStorage.getItem("access_token");

  if (!token) {
    // Save intended URL so we can redirect back after login
    const intended = window.location.pathname + window.location.search;
    if (intended !== "/" && intended !== "/login" && intended !== "/callback") {
      sessionStorage.setItem("post_login_redirect", intended);
    }
    return <Navigate to="/login" replace />;
  }

  if (hasNoRoles()) {
    return <PendingApproval />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
